import React from 'react';
import { connect } from 'react-redux';
import { Link } from "react-router-dom";
import { getCgu } from "../../api/api";
import Loader from '../Loader';

export class LegalNoticePage extends React.Component {

    componentDidMount() {
        const self = this;
        getCgu().then((response) => {
            const cgu = response.data.filter(cgu => { return cgu.id === this.props.match.params.id })[0]
            self.setState({ cgu: cgu });
        });
        window.scrollTo(0, 0);
    }

    render() {
        let content = this.state && this.state.cgu && this.state.cgu.cguContent;
        return (
            <div className="recap-page container main-container">
                <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                        <Link to="/">Accueil</Link>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">{this.state && this.state.cgu && this.state.cgu.cguTitle}</li>
                </ol>
                { this.state && this.state.cgu ?
                    <div>
                        <h1 className="text-center">
                            {this.state.cgu.cguTitle}
                        </h1>
                        <div className="container " dangerouslySetInnerHTML={{ __html: content }}>
                        </div>
                    </div> :
                    <Loader />
                }
            </div>
        )
    }
}


const mapStateToProps = state => ({
    cguData: state.cguData
})

export default connect(mapStateToProps)(LegalNoticePage);






// WEBPACK FOOTER //
// ./src/components/LegalNotice/LegalNoticePage.js